import { giphyDarkGrey, giphyLightestGrey } from '@giphy/colors'
import styled, { css, keyframes } from 'styled-components'
import { ControlSize } from 'types'
import { borderRadiusFromControlSize, heightFromControlSize } from 'utils'

const pulse = keyframes`
    0% { opacity: 1; }
    100% { opacity: 0.5; }
`

export const Avatar = styled.img`
    border-radius: inherit;
    height: 100%;
    object-fit: contain;
    width: 100%;
`

export const Container = styled.div<{ $size: ControlSize }>`
    box-sizing: border-box;
    padding: 4px;

    ${({ $size }) => css`
        border-radius: ${borderRadiusFromControlSize($size)}px;
        height: ${heightFromControlSize($size)}px;
        width: ${heightFromControlSize($size)}px;
    `}
`

export const NoAvatar = styled.div<{ $loading?: boolean }>`
    align-items: center;
    background: ${giphyDarkGrey};
    border-radius: inherit;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;

    ${({ $loading }) =>
        $loading &&
        css`
            animation: ${pulse} 0.5s linear infinite alternate;
            background: ${giphyLightestGrey};
        `}
`
